// export const REACT_APP_PROD_URL =
//   process.env.NODE_ENV === "development"
//     ? "https://222008.pocketbits.in/api"
//     : "https://api2.pocketbits.in/api";

const API = {
  UAT: "https://apidev.pocketbits.in/api",
  PROD: "https://apiprod.pocketbits.in/api",
  TEST: "https://api.testnet.pocketbits.in/api",
};
const websocketChannel = {
  UAT: "cryptoinr-websocket-test",
  PROD: "cryptoinr-websocket",
};
export const REACT_APP_PROD_URL = API.PROD;
export const PRICES_URL = API.PROD;
export const cryptoinrWebsocketChannel = websocketChannel.PROD;
export const SITE_KEY_CAPTCHA = "6Lfkp48aAAAAAFemG_0oOolHaRGuELFM2zkNwLqw";
export const CENTRIFUGE_ENDPOINT =
  "wss://socket.pocketbits.in/connection/websocket";
export const CENTRIFUGE_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM3MjIiLCJleHAiOjQxMzA2MzYyNDR9.ys08OYm3gfCEXaAdxL9Sm84OIvyqbI_hcX8TrsOa5oE";
